import React from "react";
import { polyfillLoader } from "polyfill-io-feature-detection";
import PowerBiReports from "../common/components/PowerBiReports";
import config from "../config";

// This function load polyfills only if needed. By default it uses polyfill.io
polyfillLoader({
    features: "Promise"
});

/**
 * PowerBI FunderCheck Reports Component
 */
export default () => {
    const { funderCheck } = config.powerBI;
    const funderCheckReports = [
        {
            label: "funderCheck",
            tabValue: 0,
            visuals: null
        }
    ];

    return (
        <PowerBiReports
            reportTabs={funderCheckReports}
            reportList={[funderCheck]}
        />
    );
};
